import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faFacebook, faLinkedinIn, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FormattedMessage } from 'react-intl'

import styles from './social.module.scss'

export default function Social() {
  const socials = [
    {
      icon: faFacebook,
      link: 'https://www.facebook.com/dooerhq/',
    },
    {
      icon: faInstagram,
      link: 'https://instagram.com/dooerhq',
    },
    {
      icon: faLinkedinIn,
      link: 'https://www.linkedin.com/company/dooer/',
    },
    {
      icon: faTwitter,
      link: 'https://twitter.com/DooerHQ',
    },
  ]

  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <h2 className={styles.heading}>
            <FormattedMessage defaultMessage="Följ oss på sociala medier" id="press.social.heading" />
          </h2>
          <div className={styles.icons}>
            {socials.map((i) => (
              <a href={i.link} key={i.link} rel="noopener noreferrer" target="_blank">
                <i>
                  <FontAwesomeIcon icon={i.icon} />
                </i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
